import { generateHeader } from '@/utilities/router/generate-header';

import sidebarItems from './sidebar';

import type { RouteRecordRaw } from '@bv/router';

const smsRoutes: RouteRecordRaw = {
  path: 'sms',
  name: 'sms',
  meta: {
    sidebar: sidebarItems,
    header: generateHeader('SMS'),
  },
  redirect: { name: 'sms-providers' },
  children: [
    {
      path: 'providers',
      name: 'sms-providers',
      meta: {
        breadcrumbs: [
          {
            label: 'SMS',
            route: { name: 'sms' },
          },
          {
            label: 'Providers',
            route: { name: 'sms-providers' },
          },
        ],
      },
      component: () => import('@/views/Sms/Providers.vue'),
    },
    {
      path: 'routes',
      name: 'sms-routes',
      meta: {
        breadcrumbs: [
          {
            label: 'SMS',
            route: { name: 'sms' },
          },
          {
            label: 'Routes',
            route: { name: 'sms-routes' },
          },
        ],
      },
      component: () => import('@/views/Sms/SmsRoutes/RoutesList.vue'),
    },
    {
      path: 'requests',
      name: 'sms-requests',
      meta: {
        breadcrumbs: [
          {
            label: 'SMS',
            route: { name: 'sms' },
          },
          {
            label: 'Requests',
            route: { name: 'sms-requests' },
          },
        ],
      },
      component: () => import('@/views/Sms/Requests/RequestsList.vue'),
    },
  ],
};

export default smsRoutes;
